module.exports = __webpack_public_path__ + "img/effet-points-colonne-3.aa19a361.png";